<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $tc('message.managers', 2) }}
                    </h3>
                </div>
            </div>

            <div class="card-body p-0">
                <div class="card-title">
                    <router-link :to="{ name: 'add-manager' }" v-if="can">
                        {{ $t('message.add') }}

                        <i class="fas fa-plus-circle edit-icon"></i>
                    </router-link>
                </div>
                    <b-container>
                        <b-row class="justify-content-sm-center">
                            <b-col col sm="12">
                                <!--                                <b-form-group>-->
                                <div class="vgt-global-search vgt-clearfix">
                                    <div class="vgt-global-search__input vgt-pull-left"><span class="input__icon">
                                        <div class="magnifying-glass">

                                        </div>
                                    </span>
                                        <input type="text" placeholder="Search user" class="vgt-input vgt-pull-left" v-model="searchTerm">
                                    </div>
                                    <div class="vgt-global-search__actions vgt-pull-right">

                                    </div>
                                </div>
                                <vue-good-table
                                        id="operation"
                                        :columns="mManagersColumns"
                                        :rows="mManagersFilter"
                                        :search-options="{
                                        enabled:true,
                                        externalQuery: searchTerm
                                        }"
                                        :pagination-options="paginationOptions"
                                        @on-row-click="mManagerClick"
                                />
                            </b-col>
                        </b-row>
                    </b-container>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import moment from 'moment';
    import _ from 'lodash';

    export default {
        name: "Managers",

        computed: {
            ...mapGetters(["managers",
                'hasAdminRole',
                'hasGestionnaireRole']),
                can:function(){
                return this.hasAdminRole || this.hasGestionnaireRole;
                },
            mManagers: function() {
                let mArray = [];

                _.forEach(_.orderBy(this.managers,['created_at'],['desc']), function(manager) {
                    let m = {};

                    if((typeof manager.user == 'object')  && (!_.isNull(manager.user))) {
                        let prenom = manager.user.prenom ? manager.user.prenom : '';
                        prenom =  prenom.toLowerCase();
                        m.nom =  (manager.user.nom).toUpperCase() + " "+ prenom.charAt(0).toUpperCase() + prenom.substring(1);
                        m.email = manager.user.email;
                        m.telephone = manager.user.telephone;
                        m.ville = manager.user.ville;
                        m.pays = manager.user.pays;
                        m.id = manager.user.id;
                        m.slug = manager.user.slug;
                        m.adresse = manager.user.adresse;
                    }

                    m.civilite = manager.civilite;
                    m.nationalite = manager.user.nationalite;
                    m.date = moment(manager.created_at).format('DD-MM-YYYY HH:mm');
                    m.isAuthor = manager.isAuthor;

                    mArray.push(m);
                });

                return mArray;
            },

            rows: function() {
                return this.mManagers.length;
            }
        },

        data() {
            return {
                mManagersFilter:[],
                searchTerm : '',
                paginationOptions: {
                    enabled: true,
                    mode: 'records',
                    perPageDropdown: [3, 6, 10]
                },
                mManagersColumns: [
                    {
                        field: 'nom',
                        label: this.$i18n.t('message.name'),
                    },
                    {
                        field: 'email',
                        label: this.$i18n.t('message.email'),
                    },
                    {
                        field: 'telephone',
                        label: this.$i18n.t('message.phoneNumber'),
                    },
                    /*{
                        key: 'civilite',
                        label: this.$i18n.t('message.civility'),
                    },*/
                    {
                        field: 'nationalite',
                        label: this.$i18n.t('message.nationality'),
                    },
                    /*{
                        key: 'ville',
                        label: this.$i18n.tc('message.cities', 1),
                    },
                    {
                        key: 'pays',
                        label: this.$i18n.tc('message.countries', 1),
                    },*/
                    {
                        field: 'adresse',
                        label: this.$i18n.t('message.address'),
                        sortable: true
                    },
                    // {
                    //     key: 'action',
                    //     label: this.$i18n.tc('message.operations', 1)
                    // }
                ],
                offset: 0,
                limit: -1,
            }
        },
        watch:{
            searchTerm:function (newValue, oldValue) {
                if (this.hasAdminRole || this.hasGestionnaireRole){
                    if (newValue.trim().length ==0){
                        this.mManagersFilter = [];
                    }else{
                        this.mManagersFilter = this.mManagers;
                    }
                }
            }
        },
        methods: {
            getManagers() {
                let args = {
                    offset: this.offset,
                    limit: this.limit
                };

                this.$store.dispatch('getManagers', { args : args });
            },

            mManagerClick(params){
                this.$router.push({ name: 'manager', params: { manager: params.row.slug } });
            },

            deleteManager(manager) {
                let self = this;

                let args = {
                    manager: manager
                };

                let successMessage = this.$i18n.t('message.managerDeleted');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('deleteManager', { args, index: manager, successMessage, errorMessages })
                    .then(() => {
                        self.$bvModal.hide('delete-modal-' + manager);
                    });
            }
        },

        mounted() {
            // Fetch manager list
            this.getManagers();
        }
    }
</script>

<style scoped>

</style>